import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoElastic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 129 48"
    {...props}
  >
    <g clipPath="url(#Logo_Elastic_svg__a)">
      <path
        fill="#fff"
        d="M44.787 24.053a8.69 8.69 0 0 0-5.748-8.198 12.475 12.475 0 0 0-22.362-9.68 6.627 6.627 0 0 0-10.27 7.549 8.81 8.81 0 0 0-5.792 8.231 8.7 8.7 0 0 0 5.777 8.216 12.441 12.441 0 0 0 22.329 9.628 6.616 6.616 0 0 0 10.269-7.52 8.8 8.8 0 0 0 5.794-8.232"
      />
      <path
        fill="#FEC514"
        d="m17.981 19.95 9.666 4.413 9.756-8.544c.14-.705.21-1.422.208-2.141A10.902 10.902 0 0 0 17.72 7.516l-1.625 8.406z"
      />
      <path
        fill="#00BFB3"
        d="M7.975 30.187a11 11 0 0 0-.213 2.174 10.93 10.93 0 0 0 19.967 6.146l1.61-8.387-2.15-4.108-9.701-4.421z"
      />
      <path
        fill="#F04E98"
        d="m7.917 13.46 6.624 1.563 1.45-7.532a5.233 5.233 0 0 0-8.074 5.969"
      />
      <path
        fill="#1BA9F5"
        d="M7.342 15.036a7.38 7.38 0 0 0-5.02 6.932A7.3 7.3 0 0 0 7.034 28.8l9.294-8.4-1.708-3.646z"
      />
      <path
        fill="#93C90E"
        d="M29.429 38.507a5.225 5.225 0 0 0 8.059-5.957l-6.619-1.54z"
      />
      <path
        fill="#07C"
        d="m30.774 29.267 7.286 1.703a7.37 7.37 0 0 0 5.02-6.932 7.29 7.29 0 0 0-4.709-6.814l-9.53 8.344z"
      />
      <path
        fill="#1C1E23"
        d="m62.376 31.911.883-.09.062 1.797c-1.965.297-3.948.46-5.936.488q-3.285 0-4.657-1.902-1.37-1.903-1.369-5.92 0-8.004 6.362-8.006 3.081 0 4.596 1.72t1.52 5.392l-.12 1.735H53.672q0 2.527.914 3.744.913 1.216 3.178 1.217 2.27.008 4.611-.175m-.821-6.603q-.001-2.801-.896-3.957-.897-1.155-2.922-1.158-2.026 0-3.045 1.217t-1.05 3.898zM67.02 33.985V13.96h2.283v20.025zM83.678 23.177v7.676c0 .77 1.895.73 1.895.73l-.116 2.017c-1.604 0-2.932.134-3.728-.639a13.3 13.3 0 0 1-5.476 1.142q-2.097 0-3.196-1.188-1.099-1.19-1.097-3.417 0-2.224 1.128-3.274 1.126-1.05 3.53-1.283l4.778-.455v-1.31q0-1.539-.668-2.223a2.48 2.48 0 0 0-1.828-.667h-5.997v-2.01h5.846q2.588 0 3.758 1.188 1.17 1.189 1.171 3.713m-9.379 6.208q0 2.8 2.31 2.8c1.39 0 2.77-.238 4.08-.7l.699-.244v-5.022l-4.496.426q-1.37.123-1.98.791-.608.668-.613 1.949M92.59 20.317q-3.32 0-3.32 2.31 0 1.068.77 1.507.77.44 3.468.914 2.712.476 3.836 1.325 1.124.85 1.127 3.194 0 2.346-1.507 3.44-1.507 1.095-4.398 1.096c-1.258 0-5.458-.467-5.458-.467l.123-1.977c2.413.231 4.157.404 5.335.404q1.767 0 2.693-.563.928-.563.927-1.887c0-.883-.257-1.481-.79-1.797-.535-.316-1.685-.614-3.47-.899q-2.677-.427-3.804-1.247-1.126-.822-1.127-3.045c0-1.482.513-2.568 1.569-3.286 1.055-.72 2.349-1.066 3.91-1.066 1.237 0 5.532.316 5.532.316v1.99c-2.267-.1-4.12-.262-5.417-.262M109.472 20.558h-4.839v7.276q0 2.616.38 3.438c.257.55.857.821 1.81.821l2.709-.182.154 1.887c-1.026.19-2.065.302-3.107.336q-2.373 0-3.286-1.157-.914-1.158-.912-4.414v-8.005h-2.151v-1.977h2.162v-4.657h2.251v4.657h4.829zM112.646 16.638v-2.65h2.282v2.65zm0 17.347V18.581h2.282v15.404zM124.815 18.276c1.14.048 2.276.17 3.399.367l.73.09-.09 1.856a36 36 0 0 0-3.595-.272q-2.588 0-3.514 1.232-.927 1.233-.93 4.565 0 3.337.868 4.642t3.62 1.309l3.594-.272.093 1.887a32 32 0 0 1-4.231.426q-3.56 0-4.914-1.828-1.356-1.827-1.356-6.162 0-4.336 1.461-6.087t4.865-1.753"
      />
    </g>
    <defs>
      <clipPath id="Logo_Elastic_svg__a">
        <path
          fill="#fff"
          d="M.615 0h128v48h-128z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoElastic;
